import React, { memo } from 'react';

import { Select } from '@components';
import MultipleSelect from './multipleSelect';

function Header({
  isLoading,
  onChange,
  expand,
  filters,
  yearOptions = [],
  categoryOptions = [],
}) {
  const handleSelect = (key) => (value) =>
    onChange && onChange({ ...filters, [key]: value });

  return (
    <div className="company-history-list-header">
      <div className="select-wrapper select-year-wrapper">
        <label>Year</label>
        {expand ? (
          <MultipleSelect
            loading={isLoading}
            expand={expand}
            value={filters.year}
            onSelect={handleSelect('year')}
            options={yearOptions}
          />
        ) : (
          <Select
            loading={isLoading}
            value={filters.year}
            onSelect={handleSelect('year')}
            options={yearOptions}
          />
        )}
      </div>

      <div className="select-wrapper select-category-wrapper">
        <label>Category</label>
        <MultipleSelect
          loading={isLoading}
          expand={expand}
          value={filters.category}
          hasDot
          onSelect={handleSelect('category')}
          options={categoryOptions}
        />
      </div>
    </div>
  );
}

export default memo(Header);
